export default __webpack_public_path__ + "static/neighbourcare_serice-7fca8c5d714d972fee88f13580fd28a5.png";